<div class="obs-panel">
    <div class="obs-panel__header">
        <h3 class="obs-panel__title"><i class="bi bi-eye me-2"></i>Your observations</h3>
        <span class="obs-panel__subtitle">vs last week · 8-week trend</span>
    </div>

    <ul class="obs-list">
        <li class="obs-row" *ngFor="let row of rows; trackBy: trackByKey">
            <span class="obs-row__label">{{ row.label }}</span>
            <div class="obs-row__sparkline">
                <cdss-weekly-observation-trend-bar
                    [values]="row.history"
                    [pointLabels]="row.pointLabels"
                    [ariaLabel]="row.label + ' trend over the last 8 weeks'">
                </cdss-weekly-observation-trend-bar>
            </div>
            <cdss-weekly-direction-badge [direction]="row.direction"></cdss-weekly-direction-badge>
        </li>
    </ul>

    <p class="obs-panel__legend">
        Trend bars: up = better &middot; tick = no change &middot; down = worse &middot; gap = not answered
    </p>
</div>
